module.exports = __webpack_public_path__ + "img/snickers.2c168e09.png";